import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onRemoveSuggestionPillInternal = action(
    'onRemoveSuggestionPillInternal',
    (suggestionPillId: string, suggestionPillIndex: number, scenarioId: SearchScenarioId) => ({
        suggestionPillId,
        suggestionPillIndex,
        scenarioId,
    })
);

export default onRemoveSuggestionPillInternal;
